import React, { useState } from 'react';
import WebchatBrandingTabMenuTheme from './WebchatBrandingTabMenuTheme';
import WebchatBrandingTabMenuWelcomePopup from './WebchatBrandingTabMenuWelcomePopup';
import WebchatBrandingTabMenuChat from './WebchatBrandingTabMenuChat';
import WebchatBrandingTabMenuPWA from './WebchatBrandingTabMenuPWA';
import WebchatBrandingTabMenuLinks from './WebchatBrandingTabMenuLinks';
import { Collapse } from 'antd';

const { Panel } = Collapse;

const WebchatBrandingTabMenu = () => {
  const [key, setKey] = useState([]);

  return (
    <div style={styles.webchatBrandingTabMenu}>
      <div>
          <Collapse
            activeKey={key}
            expandIconPosition="right"
            onChange={(keys) => setKey(keys)}
            className='ant-collapse-header'
          >
            <Panel className='ant-collapse-item' style={styles.panelHeader} header={<span style={styles.panelHeader}>Theme</span>} key="1">
              <WebchatBrandingTabMenuTheme/>
            </Panel>
            <Panel className='ant-collapse-item' style={styles.panelHeader} header={<span style={styles.panelHeader}>Welcome Popup</span>} key="2">
              <WebchatBrandingTabMenuWelcomePopup/>
            </Panel>
             <Panel className='ant-collapse-item' header={<span style={styles.panelHeader}>Chat</span>} key="3">
              <WebchatBrandingTabMenuChat/>
            </Panel>
             <Panel className='ant-collapse-item' header={<span style={styles.panelHeader}>Progressive Web App</span>} key="4">
              <WebchatBrandingTabMenuPWA/>
            </Panel>
             <Panel className='ant-collapse-item' header={<span style={styles.panelHeader}>Links</span>} key="5">
              <WebchatBrandingTabMenuLinks/>
            </Panel>

          </Collapse>
      </div>
    </div>
  );

};


const styles = {
  webchatBrandingTabMenu: {
    background: '#e2ebf3 !important',
    height: '80%',
    width: '100%',
    borderBottomLeftRadius: '8px',
    borderBottomRightRadius: '8px',
    position: 'relative',
    left: '10px'
    
  },
  panelHeader: {
    fontWeight: 'bold',
  },
}

export default WebchatBrandingTabMenu;